'use client';
import PrimeIcon from '@/src/components/icons/PrimeIcon';
import usePrimeStore from '@/src/lib/state-stores/primeStore';
import React, { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

export const RenderStoreTitle = ({ children }: Props) => {
  const { prime } = usePrimeStore();
  return (
    <div className="flex w-full flex-wrap items-center gap-2">
      {prime.activeSubscription && <PrimeIcon />}
      {children}
    </div>
  );
};
